import {StyleSheet} from 'react-native';
import {Colors} from '../../../../../constants/Colors';

export const styles = StyleSheet.create({
  space: {
    justifyContent: 'space-around',
    width: '100%',
    paddingVertical: 10,
  },
  container: {
    borderRadius: 3,
    backgroundColor: Colors.lightGray,
    paddingHorizontal: 7,
    marginBottom: 10,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  count: {
    fontFamily: 'TCCC-UnityHeadline Regular',
    fontSize: 12,
    lineHeight: 14,
    color: 'black',
  },
  smallButton: {
    backgroundColor: Colors.RedPallete.red,
    padding: 5,
    borderRadius: 5,
    marginHorizontal: 5,
    marginVertical: 10,
    width: 35,
    height: 35,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonText: {
    color: 'white',
    fontSize: 12,
  },
});
